export default "__VITE_ASSET__CiAtVCM7__"